import { PalletService } from "src/services/pallets";
import { useFileDownload } from "../useFileDownload";

export const usePalletFileDownload = (palletService: PalletService) => {
  const {
    mutate: download,
    isPending: isFileDownloading,
    error: fileLoadError,
    retry: retryDownload,
    reset: resetDownload
  } = useFileDownload<File>();

  const downloadFile = (palletId: string) => {
    download({
      getFileData: () => palletService.getPalletLabel(palletId)
    });
  };

  return {
    downloadFile,
    isFileDownloading,
    fileLoadError,
    retryDownload,
    resetDownload
  };
};
